import { render, staticRenderFns } from "./ContasAPagarView.vue?vue&type=template&id=43f561a8&scoped=true"
import script from "./ContasAPagarView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContasAPagarView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContasAPagarView.vue?vue&type=style&index=0&id=43f561a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f561a8",
  null
  
)

export default component.exports